import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}/tarea`;
const readUrl = (url = "") => `${urlBase}/${url}`;

export const fetchReporting = async (params) => {
  if (!params.startDate || !params.endDate) {
    return { result: { success: { result: [] } } };
  }

  const auth = `Bearer ${getToken()}`;

  const query = new URLSearchParams(params);

  let res = await fetch(readUrl(`reporting?${query.toString().replace(/%2C/g, ",")}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const fetchTareasBySucursal = async (params) => {
  if (!params.startDate || !params.endDate) {
    return { result: { success: { result: [] } } };
  }

  const auth = `Bearer ${getToken()}`;

  const query = new URLSearchParams(params);

  let res = await fetch(readUrl(`tareasporsucursal?${query.toString().replace(/%2C/g, ",")}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const fetchTareasByClientes = async (params) => {
  if (!params.startDate || !params.endDate) {
    return { result: { success: { result: [] } } };
  }

  const auth = `Bearer ${getToken()}`;

  const query = new URLSearchParams(params);

  let res = await fetch(readUrl(`tareasporcliente?${query.toString().replace(/%2C/g, ",")}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const fetchCustomers = async (params) => {
  const auth = `Bearer ${getToken()}`;

  const query = new URLSearchParams(params);

  let res = await fetch(readUrl(`clients?${query.toString().replace(/%2C/g, ",")}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const fetchPcm = async (params) => {
  if (!params.startDate || !params.endDate || !params.razonSocial) {
    return { result: { success: { result: [] } } };
  }

  const auth = `Bearer ${getToken()}`;

  const query = new URLSearchParams(params);

  let res = await fetch(readUrl(`pmc?${query.toString().replace(/%2C/g, ",")}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};
